import React, { useEffect, useState, Fragment, useRef } from "react";
import MessageModal from "../../../UI/Modal/MessageModal";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import '../../../../assets/css/print.css'
var QRCode = require("qrcode.react");


export default class ComponentToPrint extends React.Component {

  renderqr(data, searchValues) {
    let qrdata = (data == undefined || data == null || data.length === 0) ? null : (
      data.map((d) => {

        return (
          <tr>
            <td >
              <div className="card" style={{
                border: "1px solid black",
                height: "720px", width: "1200px"
              }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col" style={{ fontSize: "48px", paddingTop: "25px", paddingLeft: "30px" }}>
                      {searchValues.factory} <br></br>
                      {searchValues.route} <br></br>
                    </div>
                    <div className="col" style={{
                      paddingTop: "25px"
                    }}>
                      <div style={{ paddingLeft: "200px" }}>
                        <QRCode id={d.cardNumber} value={d.cardNumber} size={350} bgColor="#FFFFFF" fgColor="#000000" />
                        <p style={{ fontSize: "38px" }}>{d.cardNumber}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col" style={{
                      fontSize: "48px", paddingTop: "120px",
                      paddingLeft: "30px"
                    }}>
                      {d.registrationNumber} <br></br>
                      {d.name}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        )
      })
    );
    return (
      <div>
        {qrdata}
      </div>
    )
  }

  render() {
    const renderqr = this.renderqr(this.props.data, this.props.searchValues);
    return (
      <table>
        <tbody>
          {renderqr}
        </tbody>
      </table>
    );
  };
}


















